import Vue from 'vue';
import VueRouter from 'vue-router';

import { UserRouter } from '@/router/User/index.js';
import { EventsRouter } from '@/router/Events/index.js';
import { CheckoutRouter } from '@/router/Checkout/index.js';
import { MiniSitesRouter } from '@/router/MiniSites/index.js';
import { AsDeporteRouter } from '@/router/AsDeporte/index.js';
import { ErrorPagesRouter } from '@/router/ErrorPages/index.js';
import { AdminRouter, ADMIN_LAYOUT } from '@/router/Admin/index.js';
import { PurchaseOrdersRouter } from '@/router/PurchaseOrders/index.js';
import { LandingRouter, CHUSPIC_LAYOUT_WEB, LANDING_NAME_ROUTER } from '@/router/Landing/index.js';

Vue.use(VueRouter);

const MASTER_TENANT_NAME = 'public';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home/Index.vue'),
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: () => import('@/views/Maintenance.vue'),
    meta: { layout: 'MaintenanceLayout' },
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/Contact.vue'),
  },
  {
    path: '/privacy-policies',
    name: 'PrivacyPolicies',
    component: () => import('@/views/PrivacyPolicies.vue'),
  },
  {
    path: '/terms-conditions',
    name: 'TermsConditions',
    component: () => import('@/views/TermConditions.vue'),
  },
  ...UserRouter,
  ...AdminRouter,
  ...EventsRouter,
  ...LandingRouter,
  ...CheckoutRouter,
  ...MiniSitesRouter,
  ...AsDeporteRouter,
  ...ErrorPagesRouter,
  ...PurchaseOrdersRouter,
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach(async (_to, _from, next) => {
  const tenantName = document.querySelector('body').dataset.tenantName;

  if (
    tenantName == MASTER_TENANT_NAME &&
    _to.meta.layout != CHUSPIC_LAYOUT_WEB &&
    _to.meta.layout != ADMIN_LAYOUT
  ) {
    next({ name: LANDING_NAME_ROUTER });
    return;
  }

  // Admin-only SPA screens require admin or manager access. Screens marked
  // access: 'category' (file manager, presets) stay reachable by photographers
  // with per-category grants; server-side APIs remain the source of truth for
  // what data each user can actually see.
  if (_to.meta.layout == ADMIN_LAYOUT && _to.meta.access === 'admin') {
    // Lazy import avoids a circular dependency (store modules import router).
    const { default: store } = await import('@/store/index.js');
    let currentUser = store.getters['Auth/currentUser'];

    if (!currentUser.signed()) {
      await store.dispatch('Auth/fetchUser');
      currentUser = store.getters['Auth/currentUser'];
    }

    if (!currentUser.hasAdminOrManagerAccess()) {
      next({ name: 'Home' });
      return;
    }
  }

  window.scrollTo(0, 0);
  next();
});

router.onError((error) => {
  console.error('[Router] Navigation error:', error?.message);
  console.error('[Router] Stack:', error?.stack);
});

export default router;
